import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';

import { Input, NewCheckbox } from 'components';
import { WarningIcon } from 'icons';

import messages from 'messages';

function Recipient({ index, quantity, giftcard, value, ...props }) {
    const [name, setName] = useState(value.name);
    const [email, setEmail] = useState(value.email);
    const [message, setMessage] = useState(value.message);
    const [disable, setDisabled] = useState(false);
    const [sameReceiver, setSameReceiver] = useState(
        value.sameReceiver ? value.sameReceiver : false,
    );
    const [sameMessage, setSameMessage] = useState(value.sameMessage ? value.sameMessage : false);
    const [errors, setErrors] = useState({ name: false, email: false });
    const [update, setUpdate] = useState(false);

    const { formatMessage } = props.intl;

    const renderCheckSameReceiver = () => {
        if (index === 1 && quantity > 1) {
            return (
                <NewCheckbox
                    checked={sameReceiver}
                    label={
                        <span data-test="i-accept">
                            {formatMessage(messages.recipientSendSameReceiver)}
                        </span>
                    }
                    onChange={(value) => setSameReceiver(value)}
                    data-test="button-send-same-receiver"
                />
            );
        }
    };

    const renderCheckSameMessage = () => {
        if (index === 1 && quantity > 1 && !sameReceiver) {
            return (
                <NewCheckbox
                    checked={sameMessage}
                    label={
                        <span data-test="i-accept">
                            {formatMessage(messages.recipientApplyMessageAll)}
                        </span>
                    }
                    onChange={(value) => setSameMessage(value)}
                    data-test="button-send-same-message"
                />
            );
        }
    };

    const save = () => {
        if (name || email || sameReceiver !== null || sameMessage !== null) {
            const recipient = {
                name,
                email,
                message,
                index: index - 1,
                visible: true,
                edit: true,
            };

            if (index === 1) {
                Object.assign(recipient, { ...recipient, sameReceiver });

                Object.assign(recipient, { ...recipient, sameMessage });
            }

            if (errors.name === false && errors.email === false) {
                props.callback(recipient);
            }
        }
    };

    const handleName = (value) => {
        setErrors({ ...errors, name: false });
        setName(value);

        if (value === null) {
            setErrors({ ...errors, name: true });
        }
    };

    const handleEmail = (value) => {
        setErrors({ ...errors, email: false });
        setEmail(value);
        const pattern = /\S+@\S+\.\S+/;
        const result = pattern.test(value);

        if (result === false) {
            setErrors({ ...errors, email: true });
        }
    };

    useEffect(() => {
        save();
        if (update) setUpdate(false);
    }, [name, email, message, sameReceiver, sameMessage, update]);

    useEffect(() => {
        setMessage(value.message);

        if (value.edit === false) {
            setDisabled(true);
        } else {
            setDisabled(false);
        }
    }, [JSON.stringify(value)]);

    useEffect(() => {
        setErrors({ name: false, email: false });

        if (props.added) {
            if (name === null && !email) {
                setErrors({ name: true, email: true });

                return;
            }

            if (name === null) {
                setErrors({ ...errors, name: true });

                return;
            }

            if (!email || /\S+@\S+\.\S+/.test(email) === false) {
                setErrors({ ...errors, email: true });

                return;
            }
        }
    }, [props.added]);

    if (value.visible === false) return '';

    return (
        <div className="recipient">
            <div className="flex-block">
                <p className="recipient">
                    {formatMessage(messages.recipientLabel)} {index}
                </p>
                {renderCheckSameReceiver()}
            </div>
            <div className="input-field name-field">
                <Input
                    type="text"
                    placeholder={formatMessage(messages.genericLabelName)}
                    value={name}
                    onChange={(value) => handleName(value)}
                    customStyles={{
                        margin: '10px auto 8px',
                        width: '100%',
                    }}
                    data-test="input-name"
                    error={errors?.name ? 'error-field' : ''}
                />

                {errors.name}

                {errors?.name ? (
                    <p className="error">
                        <WarningIcon size={16} />
                        {formatMessage(messages.errorRequired)}
                    </p>
                ) : (
                    ''
                )}
            </div>

            <div className="input-field">
                <Input
                    type="text"
                    placeholder={formatMessage(messages.genericLabelEmail)}
                    value={email}
                    onChange={(value) => handleEmail(value)}
                    customStyles={{
                        margin: '10px auto 8px',
                        width: '100%',
                    }}
                    data-test="input-email"
                    error={errors?.email ? 'error-field' : ''}
                />

                {errors?.email ? (
                    <p className="error">
                        <WarningIcon size={16} />
                        {formatMessage(messages.errorEmail)}
                    </p>
                ) : (
                    ''
                )}
            </div>

            <div className="message-field">
                <div className="flex-block">
                    <p>{formatMessage(messages.genericLabelMessage)}</p>
                    {renderCheckSameMessage()}
                </div>
                <Input
                    type="textarea"
                    placeholder={formatMessage(messages.recipientMessagePlaceholder)}
                    value={message}
                    onChange={(value) => setMessage(value)}
                    maxLength={1000}
                    disabled={disable}
                    data-test="input-message"
                />
            </div>
        </div>
    );
}

export default injectIntl(Recipient);
